import { ScrollTop } from "@/components/commons/ScrollTop";
import { RoleGuard } from "@/components/guards/RoleGuard";
import { AppDrawer } from "@/components/layout/elements/AppDrawer";
import { AppHeader } from "@/components/layout/elements/AppHeader";
import { withAuth } from "@/hoc/withAuth";
import { useVisible } from "@/hooks/useVisible";
import { InitSetupProvider } from "@/providers/InitSetupProvider";
import { SocketProvider } from "@/providers/SocketProvider";
import { background } from "@/theme/colors";
import { spacing } from "@/theme/variables";
import { FCC } from "@/types/common";
import { Box, Stack, styled } from "@mui/material";
import { Outlet } from "react-router-dom";

export const MatchLayout: FCC = ({ children }) => {
  const showDrawer = useVisible();

  return (
    <InitSetupProvider>
      <ScrollTop />
      <SocketProvider>
        <AppHeader isOpenDrawer={showDrawer.visible} toggleDrawer={showDrawer.toggle} />
        <StackWrapper direction="row">
          <AppDrawer isOpenDrawer={showDrawer.visible} toggleDrawer={showDrawer.toggle} />
          <ChildrenWrapper onClick={showDrawer.close}>
            <RoleGuard>
              <Outlet />
              {children}
            </RoleGuard>
          </ChildrenWrapper>
        </StackWrapper>
      </SocketProvider>
    </InitSetupProvider>
  );
};

export const MatchLayoutWithAuth = withAuth(MatchLayout);

const ChildrenWrapper = styled(Box)`
  padding: ${spacing.md};
  position: relative;
  flex: 1 1 0;
  min-width: 0;
  margin: 0 auto;
`;

const StackWrapper = styled(Stack)`
  min-height: calc(100vh - 57px);
  background-color: ${background.primary};
`;
